import React from 'react'
import { useSelector } from 'react-redux'
import * as ReactBootstrap from 'react-bootstrap'
import { isMobileDevice } from '../../helpers'
import { Slider } from '../../components'
import { TrackStatusPage } from '../TrackStatusPage'
import './style.css'
import { RootState } from '../../state/reducer'

export const Home = () => {
  const { productName, clientName, salesURL } = useSelector((state: RootState) => state.application)
  const brandName = clientName.split(" ")[0] // e.g., "Unicorn"
  const isMobile = isMobileDevice
  const classSuffix = isMobile ? 'sm' : 'md'
  const sliderWidth = isMobile ? '100vw' : '50vw'

  return (
      <div className="dark-background h-auto pl-0 pr-0">
        <div className={`text-center banner-${classSuffix} text-dark animated-fade-in`}>
          <h1 className="display-1 text-center">
            <strong className="text-white">{productName}</strong>
          </h1>

          <div
              className="lead display-6 p-2 animated-fade-in"
              style={{display: 'inline-block', width: sliderWidth}}
          >
            <strong className="lead-mktg text-white">
              {`Customer service platform by ${clientName}`}
            </strong>

            <div className="p-2">
              <ReactBootstrap.Row>
                <ReactBootstrap.Col xs={12}>
                  <Slider
                      variant="success"
                      header={"Track Your Tickets"}
                      className="demo-button mt-5 mb-3 btn-block"
                      title="Need Help? Track Here"
                      overlayClassName="on-top"
                      sliderWidth={sliderWidth}
                  >
                    <TrackStatusPage/>
                  </Slider>
                </ReactBootstrap.Col>

                {salesURL && (
                    <ReactBootstrap.Col xs={12}>
                      <ReactBootstrap.Button
                          className="btn-warning mt-5 mb-3 btn-block animated-fade-in"
                          href={salesURL}
                          target="_blank"
                          rel="noopener noreferrer"
                      >
                        Click here to Shop With {brandName}
                      </ReactBootstrap.Button>
                    </ReactBootstrap.Col>
                )}
              </ReactBootstrap.Row>
            </div>
          </div>
        </div>
        <footer className="sticky-footer text-center text-white p-2">
          © 2025 Easeon Business Intelligence Solutions. All rights reserved.
        </footer>
      </div>
  )
}
